// extracted by mini-css-extract-plugin
export default {"MetatagFilterMenu":"MetatagFilterMenuhFRkg","metatagFilterMenu":"MetatagFilterMenuhFRkg"};